import { createAuthClient } from 'better-auth/react'
import { inferAdditionalFields } from 'better-auth/client/plugins'
import type { Auth } from './auth'
import { useSyncExternalStore } from 'react'

export const authClient = createAuthClient({
  plugins: [inferAdditionalFields<Auth>()],
})

const subscribeHydration = () => () => {}
const clientHydration = () => true
const serverHydration = () => false

/** Deferred routes must hydrate against the same signed-out shape as the server. */
export function useHydratedSession() {
  const session = authClient.useSession()
  const hydrated = useSyncExternalStore(subscribeHydration, clientHydration, serverHydration)
  return { ...session, data: hydrated ? session.data : null, isPending: !hydrated || session.isPending }
}
